module.exports = new __parcel__URL__("battleroyale_evades_button_inactive.94c81673.png").toString();